import { httpService } from 'src/services/app/http.service'
import { USER_ENDPOINTS } from 'src/services/consts/api.const'
import { USER_FUNCTION_NAMES, USER_FUNCTION_STATUS } from 'src/services/consts/user.const'
import { refactorUserFunctionsResponse } from 'src/services/helpers/user.helper'

export const userService = {
  getUserInfo,
  addAdditionalEmail,
  verifyAdditionalEmail,
  removeAdditionalEmail,
}

async function getUserInfo() {
  return postUserFunction({ function: USER_FUNCTION_NAMES.GET_USER_INFO })
}

async function addAdditionalEmail({ email }) {
  const envelope = await postUserFunction({
    function: USER_FUNCTION_NAMES.ADD_ADDITIONAL_EMAIL,
    email,
  })
  if (envelope.status !== USER_FUNCTION_STATUS.VERIFICATION_SENT) {
    throw new Error(`Unexpected status: ${envelope.status || 'unknown'}`)
  }
  if (envelope.userInfo == null) {
    throw new Error('Missing user info')
  }
  return envelope
}

async function verifyAdditionalEmail({ email, code }) {
  const envelope = await postUserFunction({
    function: USER_FUNCTION_NAMES.VERIFY_ADDITIONAL_EMAIL,
    email,
    code,
  })
  const { status } = envelope
  if (
    status !== USER_FUNCTION_STATUS.SUCCESS &&
    status !== USER_FUNCTION_STATUS.INVALID &&
    status !== USER_FUNCTION_STATUS.EXPIRED
  ) {
    throw new Error(`Unexpected status: ${status || 'unknown'}`)
  }
  if (status === USER_FUNCTION_STATUS.SUCCESS && envelope.userInfo == null) {
    throw new Error('Missing user info')
  }
  return envelope
}

async function removeAdditionalEmail({ email, isPendingVerification = false }) {
  const envelope = await postUserFunction({
    function: isPendingVerification
      ? USER_FUNCTION_NAMES.REMOVE_EMAIL_VERIFICATION
      : USER_FUNCTION_NAMES.REMOVE_ADDITIONAL_EMAIL,
    email,
  })
  if (envelope.status !== USER_FUNCTION_STATUS.SUCCESS) {
    throw new Error(`Unexpected status: ${envelope.status || 'unknown'}`)
  }
  if (envelope.userInfo == null) {
    throw new Error('Missing user info')
  }
  return envelope
}

// The response interceptor rejects 200 bodies that carry an `error` field
// (http.service.js). For /user/functions, `status` + `error` can be an expected
// outcome (verify -> invalid / expired), so recover the envelope here.
// Callers throw when the status is one they do not handle. Transport/HTTP errors still throw.
async function postUserFunction(payload) {
  try {
    const data = await httpService.post(USER_ENDPOINTS.USER_FUNCTIONS, payload)
    return refactorUserFunctionsResponse(data)
  } catch (error) {
    const responseData = error.response?.data
    if (
      error.response?.status === 200 &&
      typeof responseData?.status === 'string' &&
      responseData.status
    ) {
      return refactorUserFunctionsResponse(responseData)
    }
    throw error
  }
}
